/* eslint-disable */
import { StyleSheet } from "react-native"
import { Colors, Fonts, Metrics, ApplicationStyles } from "../../Themes/"

export default StyleSheet.create({
  ...ApplicationStyles.screen,
  container: {
    paddingTop: Metrics.baseMargin * 2,
    paddingBottom: Metrics.baseMargin,
    paddingLeft: Metrics.baseMargin,
    paddingRight: Metrics.baseMargin
  },
  centerText: {
    textAlign: `center`,
  
  },
  normalText : {
    fontSize: 15,
    fontFamily: Fonts.style.font.bold
  },
  titleText: {
    fontFamily: Fonts.style.font.regular
  },
  textHeader: {
    fontFamily: Fonts.style.font.light
  },
  header: {
    marginBottom: 5
  },
  headerTitle: {
    alignSelf: 'center',
    textAlign: 'center',
    fontFamily: Fonts.style.font.regular,
    color: 'black',
    fontWeight: '300',
    fontSize: 15
  },

  formText: {
    ...Fonts.style.input,
    // fontSize: 22,
    // color: Colors.text
    marginTop: 8,
    marginBottom: 8
  },
  formError: {
    ...Fonts.style.input,
    // fontSize: 22,
    color: Colors.error,
    marginTop: 2,
    marginBottom: 8
  },
  input: {
    ...Fonts.style.input,
    borderColor: "gray",
    borderWidth: 1,
    marginBottom: 5,
    padding: 5,
    width: 200
  },
  inputWide: {
    ...Fonts.style.input,
    borderColor: "gray",
    borderWidth: 1,
    marginBottom: 5,
    padding: 5
  },
  inputWideError: {
    ...Fonts.style.input,
    borderColor: Colors.error,
    borderWidth: 1,
    marginBottom: 0,
    padding: 5
  },
  inputWideDisabled: {
    ...Fonts.style.input,
    // color: Colors.disabled, // adding this we get no update, adding key to component and navigation flickers
    borderColor: "#cccccc",
    borderWidth: 1,
    marginBottom: 5,
    padding: 5
  },
  avatarContainer: {
    height: 120,
    flex: 1,
    flexDirection: "row",
    justifyContent: "center"
  },
  avatarSpacer: {
    height: 120
  },
  avatarBorder: {
    paddingTop: 2,
    paddingLeft: 2,
    height: 120,
    width: 120,
    borderRadius: 60,
    backgroundColor: "green"
  },
  avatar: {
    height: 116,
    width: 116,
    borderRadius: 58
  }
})
